import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {EStorageKeys} from 'src/constants';
import {listenerMiddleware} from 'src/models';

import {TFilters} from './definitions';

const initialState = () => {
  const rememberedFilters = sessionStorage.getItem(EStorageKeys.SUPPORT_VERIFICATIONS_FILTERS);

  return {
    filters: rememberedFilters ? JSON.parse(rememberedFilters) : {},
  };
};

const supportVerificationsSlice = createSlice({
  name: 'supportVerifications',
  initialState,
  reducers: {
    setFilters(state, action: PayloadAction<TFilters>) {
      state.filters = action.payload;
    },
  },
});

export const {setFilters: setFiltersAction} = supportVerificationsSlice.actions;
export const selectFilters = (state: TRootState) => state.supportVerifications.filters as TFilters;

listenerMiddleware.startListening({
  actionCreator: setFiltersAction,
  effect: (action) => {
    sessionStorage.setItem(
      EStorageKeys.SUPPORT_VERIFICATIONS_FILTERS,
      JSON.stringify(action.payload),
    );
  },
});

export default supportVerificationsSlice.reducer;
